/**
 * @file The refusal thrown when analytics configuration is missing or malformed: by
 * `parseAnalyticsParameters` and `readAnalyticsParameters` for `parameters/analytics`, by
 * `runDueReports` when `parameters/analyticsBindings` is absent, by `runNamedQuery` when a query
 * needs a binding, table or optional key the stored configuration leaves unset, and by
 * `resolveAnalyticsScope` for My team when `teamBusinessGroups` is malformed. `key` is the dotted
 * key (`calendar.timeZone`, `roles.lineItemStatus`) or the document path when the document is
 * absent. Nothing falls back to a guessed value beyond the parser's documented defaults, and the
 * message names the key alone, never a stored value.
 */
import type { AnalyticsRefusalCode } from './Analytics.NamedQuery.types';

export class AnalyticsNotConfigured extends Error {
    readonly code = 'notConfigured' satisfies AnalyticsRefusalCode;

    constructor(readonly key: string) {
        super(`Analytics is not configured: ${key} is missing or malformed`);
        this.name = 'AnalyticsNotConfigured';
    }
}
